import React, { useState, useEffect, useRef } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch, useSelector } from "react-redux";
import { getLoginType, getSequnceSort } from "../../../../utils/helper";
import { showModal } from "../../../../redux/actions";
import * as image from "../../../../resources/images";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getDimModuleChallngObj } from "../../../../redux/actions/APIs";
import { ShimmerCategoryList } from "react-shimmer-effects";
import ReactPlayer from "react-player";
import { Line } from "rc-progress";
const Newmodulelesson = ({getMyActivity, setModuleINdex, moduleIndex,charImage, getStartVideo }) => {
    const param = useParams();
        const playerRef = useRef(null);
         const [isPLay, setIsPlay] = useState(true);
    const dispatch = useDispatch();
    const {
        socialActivityData,
        dimModuleObjResp,
        defaultChildData,
        loggedInUser,
    } = useSelector((state) => state.collections);

    const loginType = getLoginType(loggedInUser);

    const [activityData, setActivityData] = useState();


    useEffect(() => {
        let getUserId = param?.id ? param?.id : defaultChildData?.id;
        dispatch(
            getDimModuleChallngObj(
                getUserId,
                param?.activityId,
                param?.courseId,
            )
        );
    }, [])

    useEffect(() => {
        if (dimModuleObjResp?.records?.length > 0) {
            setActivityData(dimModuleObjResp?.records[0]);
        } else {
            setActivityData();
        }
    }, [dimModuleObjResp])

    const handleModule = (modInd) => {
        setModuleINdex(modInd);
    }

   
    // console.log("LessonModuleChallenge : ", dimModuleObjResp, getMyActivity);
    return (
        <>
            {dimModuleObjResp?.records?.length > 0 ? (
                <>
                    <div className="">
                        <div className="Course_height">
                            <div class="gridSection">
                            
                              
                                <div className="planprogresdash">
                                    {
                                    !getMyActivity?.isCompleted && !activityData?.isComplete  && 
                                    (
                                        <div class="planprogress_list  p-0">
                                        <div class=" badgesdetails_card d-block">
                                            <div>
                                                <div className="w-100">
                                                    <div class="clbcarddtl p-3 w-100">
                                                        <div class="lbuserdtl flextwo w-100">
                                                            <div class="lbuserimage text-center">
                                                                {activityData?.badge?.imageUrl ? (
                                                                    <img src={activityData?.badge?.imageUrl} alt="" />
                                                                ) : (
                                                                    <img src={image.animal_badgesdefault} alt="" />
                                                                )}
                                                            </div>
                                                            <div class="lbuserName pb-2">
                                                                <h3 className="">{activityData?.badge?.badgesName}</h3>
                                                                <p>  {activityData?.badge?.description}</p>
                                                                {/* <p className="p-0 mt-2">
                                                                <strong>
                                                                    <img
                                                                        src="/static/media/mortarboard.ef1b753378e48b5a9009.png"
                                                                        class="mr-2"
                                                                    />
                                                                </strong>{" "}
                                                                {activityData?.badge?.courseName}
                                                            </p>
                                                            <p className="mt-1">
                                                                <strong></strong>{activityData?.badge?.activityName}
                                                            </p> */}
                                                                <p className="m-0">
                                                                    {/* <strong className="d-block">About Badge:</strong> */}

                                                                    {/* {activityData?.badge?.bragAboutIt} */}
                                                                </p>
                                                                <p>
                                                                    {/* <strong className="d-block">Description:</strong> */}
                                                                  
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                {
                                  (!loginType || getMyActivity?.isCompleted) &&
                                    (
                                    <>
                                         {activityData && activityData?.videoUrl ? (
                                             <div class="StoryScene mb-4 pb-2">
                                                <div class="video_container">
                                                {!isPLay && (
                                                    <div className="video_icons">
                                                        <img src={image.Video_btn} />
                                                    </div>
                                                )}
                                                <div class="w-100 br-18">
                                                <ReactPlayer
                                                ref={playerRef}
                                                width={"100%"}
                                                height="100%"
                                                controls={true}
                                                onPlay={() => setIsPlay(true)}
                                                onPause={() => setIsPlay(false)}
                                                playing={isPLay}
                                                url={activityData?.videoUrl}
                                                    config={{
                                                        file: {
                                                            attributes: {
                                                                controlsList: "nodownload",
                                                            },
                                                        },
                                                    }}
                                                                                />
                                                    </div>
                                                    </div>
                                            </div>
                                         ) : ("")}

                                    </>
                                    
                                )}
                                    <div className="module_objective p-0">
                                        <div class="plans_contents_ pl-3 px-3">
                                            {/* <h3 class="mb-2 mt-3">
                                            <span class="_module_name">C1</span>
                                            {activityData?.badge?.courseName}
                                        </h3>
                                        <h4 class="mb-2">
                                            <span class="_module_name">M1</span>
                                            {activityData?.badge?.activityName}
                                        </h4>
                                        <div className="tabgrid mt-3">
                                            <ul class="objectibe_module_list flex">
                                                {activityData?.activityObjectives?.map((module, index) => (
                                                    <li className={`${moduleIndex === index ? "active-tabs" : ""} pointer tabs w-25 justify-content-center`}
                                                        onClick={() => handleModule(index)}>
                                                        M{index + 1}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div> */}
                                     
                                            <h2 class="mb-3 flex">
                                                Module Objectives{" "}
                                                <span class="Score_points">
                                                    {/* <span class="earnnoCoin">{loginType && activityData?.points ? activityData?.points : 0}</span>
                                                    <img src={image.money_bag}></img> */}
                                                    <img src={image.point_bag} alt="pointbag" />
                                                    <span className="earnnoCoin">{loginType && activityData?.points ? activityData?.points : 0}</span>
                                                </span>
                                            </h2>
                                            <ul>
                                                {getSequnceSort(activityData?.objectives)?.map((modObj, key) => (
                                                  <>
                                                    <div className="module_obj_list flexone mb-4">
                                                    <div className="objcontent w-50">
                                                          <p class="p flextwo progess_navigation ">
                                                            {modObj?.progress === 100 ? (
                                                                <strong className=" mr-2"><i class="fa-regular fa-badge-check"></i></strong>
                                                            ) : modObj?.progress > 0 ? (
                                                                <span className="circleone mr-2"><i class="fa-solid fa-spinner-scale"></i></span>
                                                            ) : (
                                                                <span className="circleone lockecobj mr-2"><i class="fa-solid fa-lock-keyhole"></i></span>
                                                            ) } 
                                                            {modObj?.content}
                                                          </p>
                                                    </div>

                                                  
                                                    <div className={`${getMyActivity?.dimName}DimCard objpercentage w-40`}>
                                                       <p class="p3 textuppercase mb-1"><span class="mr-1">{modObj?.progress}%</span> progress<span class="ml-1">
                                                           {modObj?.progress >= 25 && modObj?.progress < 50 ? '🎉' : ''}
                                                            {modObj?.progress >= 50 && modObj?.progress < 75 ? '🤩' : ''}
                                                            {modObj?.progress >= 75 && modObj?.progress < 100 ? '🥳' : ''}
                                                            {modObj?.progress >= 100 ? '🎊🥳🤩🎉' : ''} 
                                                        </span></p>
                                                       
                                                        <Line percent={modObj?.progress} strokeWidth={3} strokeColor="#85b812" />
                                                    </div>
                                                  </div>
                                                       {/* <li class="d-flex">
                                                        <div class="obj_prog_ress">
                                                            <span class="Progresslistitem m-0">
                                                                <span
                                                                    class="diemensionalProgress progressbar1"
                                                                    style={{
                                                                        maxWidth: `${modObj?.progress}%`,
                                                                        background: "rgb(32, 201, 151)",
                                                                    }}
                                                                ></span>
                                                                <span
                                                                    class="percentage_marker"
                                                                    style={{ left: `${modObj?.progress}%` }}
                                                                >
                                                                    {modObj?.progress}<sub>%</sub>
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <span class="">
                                                            {modObj?.content}
                                                        </span>
                                                    </li> */}
                                                 
                                                   </>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div class="LeftPanelFooter input-group full-Width-group basic_details_form pagebuttonStrip "><div class="form-group BDsubmitbutton d-flex justify-content-between align-items-center m-0 "></div></div> */}
                </>
            ) : (
                <div>
                    <ShimmerCategoryList items={4} categoryStyle="STYLE_SIX" />
                </div>
            )}

        </>
    );
};
export default Newmodulelesson;
